export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_PRODUCT = 'GET_PRODUCT'
export const GET_UPI_PRODUCT = 'GET_UPI_PRODUCT'
export const GET_CATALOG_PRODUCT = 'GET_CATALOG_PRODUCT'
export const GET_AI_PRODUCT = 'GET_AI_PRODUCT'
export const GET_VIN_PRODUCT = 'GET_VIN_PRODUCT'
export const GET_IMAGE_PRODUCT = 'GET_IMAGE_PRODUCT'
